import { assessmentQuestionsFr } from "./data/assessmentData.fr";
import {
  CROSS_P2_FR,
  CROSS_P3_EN_AVANCE_FR,
  CROSS_P3_EN_RETRAIT_FR,
  CROSS_P3_UNIFORME_FR,
  PILLAR_FEEDBACKS_FR,
} from "./data/feedbackData.fr";
import type { LocaleStrings } from "./utils";

const fr: LocaleStrings = {
  ui: {
    "nav.previous": "Précédent",
    "nav.next": "Suivant",
    "nav.results": "Résultats",
    "groups.1": "Stratégie & Pilotage",
    "groups.2": "Marque & Expérience",
    "groups.3": "Contenu & Visibilité",
    "groups.4": "IA & Outils",
    "welcome.title":
      "Quel est le niveau de maturité marketing de votre organisation ?",
    "welcome.cta": "Commencez ici",
    "welcome.tagline": "Résultats immédiats · Aucun engagement",
    "welcome.intro.bold": "Des insights sur mesure pour votre organisation.",
    "welcome.intro.p1":
      "Le marketing B2B est à un point de bascule. L'IA redéfinit le savoir-faire des équipes marketing. Elle peut amplifier les forces... mais aussi accentuer les faiblesses.",
    "welcome.intro.p2":
      "Ce qui fonctionnait il y a deux ans ne suffit plus. Ce qui fonctionnera demain n'est pas encore clair pour tout le monde.",
    "welcome.intro.p3":
      "En 4 axes (stratégie, marque, contenu et IA), cette analyse vous donne une vision claire de votre marketing et identifie LA priorité pour avancer.",
    "welcome.summary.title": "En résumé",
    "welcome.summary.li1": "{n} questions",
    "welcome.summary.li2": "4 axes : stratégie, marque, contenu et IA",
    "welcome.summary.li3": "Vos résultats immédiats · Sans aucun engagement",
    "emailCapture.emailLabel":
      "Laissez votre email pour enregistrer là où vous en êtes et pouvoir y revenir quand vous le souhaitez, et recevoir vos résultats à la fin.",
    "emailCapture.emailPlaceholder": "Votre email professionnel",
    "emailCapture.emailPrivacy":
      "Votre email reste chez nous. On ne le transmettra à personne. Promis.",
    "emailCapture.errorEmpty": "Veuillez entrer votre email",
    "emailCapture.errorInvalid": "Veuillez entrer un email valide",
    "emailCapture.errorEmailForLink":
      "Laissez-nous votre email, on vous envoie le lien pour pouvoir reprendre plus tard.",
    "emailCapture.errorCompany":
      "Veuillez renseigner le nom de votre entreprise",
    "emailCapture.company.title": "Vérifions votre entreprise",
    "emailCapture.company.withSuggestion":
      "Nous avons identifié cette entreprise à partir de votre email. Pouvez-vous confirmer ou corriger ?",
    "emailCapture.company.noSuggestion":
      "Nous n'avons pas trouvé automatiquement votre entreprise. Pouvez-vous nous l'indiquer ?",
    "emailCapture.company.placeholder": "Nom de votre entreprise",
    "emailCapture.continue": "Continuer",
    "emailCapture.pauseLater.hint":
      "Pas le temps maintenant ? Entrez votre email ci-dessus et vous recevrez un lien pour reprendre exactement où vous en êtes.",
    "emailCapture.pauseLater.button": "Reprendre plus tard",
    "emailCapture.previous": "Précédent",
    "emailCapture.themeTitle": "Thème 1 :",
    "companyCapture.title": "Avant vos résultats",
    "companyCapture.subtitle":
      "Nous préparons votre synthèse. Pouvez-vous confirmer votre entreprise pour personnaliser correctement les résultats ?",
    "companyCapture.withSuggestion":
      "Nous avons identifié cette entreprise à partir de votre email. Vous pouvez la confirmer ou la corriger.",
    "companyCapture.noSuggestion":
      "Nous n'avons pas trouvé automatiquement votre entreprise. Pouvez-vous nous l'indiquer ?",
    "companyCapture.placeholder": "Nom de votre entreprise",
    "companyCapture.errorEmpty":
      "Veuillez renseigner le nom de votre entreprise",
    "companyCapture.confirm": "Confirmer et voir mes résultats",
    "paused.title": "Votre progression est sauvegardée.",
    "paused.body":
      "Vous pouvez reprendre à tout moment depuis ce lien. Votre progression est enregistrée dans votre navigateur.",
    "paused.copy": "Copier",
    "paused.copied": "Copié !",
    "paused.emailReminder":
      "Vous recevrez aussi un email de rappel avec ce lien.",
    "paused.continueNow": "Finalement, je continue maintenant",
    "loading.title": "On analyse vos réponses, comptez une bonne minute...",
    "loading.msg1":
      "On croise vos réponses avec ce que Be-one a appris en vingt ans de marketing B2B.",
    "loading.msg2":
      "Analyse en cours (un vrai raisonnement, pas un copier-coller).",
    "loading.msg3":
      "Notre agent IA lit vos réponses attentivement et réfléchit.",
    "loading.msg4":
      "On confronte vos réponses entre elles. Là où ça frotte, il y a quelque chose à apprendre.",
    "loading.msg5":
      "Vos réponses parlent entre elles. La conversation devient piquante.",
    "loading.msg6":
      "Notre agent IA rédige votre analyse. On s'assure qu'il ne raconte pas n'importe quoi.",
    "loading.msg7":
      "On garde vos résultats sous clé. Vos concurrents peuvent toujours rêver.",
    "loading.msg8":
      "On écrit vos recommandations. La vérité d'abord, le confort ensuite.",
    "loading.msg9":
      "On peaufine. Ce qui n'est pas utile ne survivra pas à la relecture.",
    "loading.msg10": "Alibi fourni : vous travaillez sur votre stratégie.",
    "loading.msg11":
      "Temps bien investi. Au prochain codir, vous serez le seul avec des réponses.",
    "themeComplete.title": "Thème {num} :",
    "themeComplete.continue": "Continuer vers le prochain thème {next}",
    "themeComplete.previous": "Précédent",
    "radar.progress": "Thème {num}/4",
    "radar.ariaLabel": "Le radar de vérité : vos scores marketing",
    "radar.svgTitle": "Le radar de vérité : vos scores marketing",
    "radar.svgDesc":
      "Vos quatre piliers B2B au radar, notés sur 4. Certains vacillent peut-être.",
    "results.title": "Vos résultats",
    "results.subtitle": "Voici ce que révèlent vos réponses.",
    "results.situation": "Situation",
    "results.priority": "Votre priorité",
    "results.why": "Pourquoi cette priorité",
    "results.noAnalysis.line1":
      "L'analyse personnalisée nécessite une connexion internet.",
    "results.noAnalysis.line2":
      'Reconnectez-vous et cliquez sur "Réessayer" pour la recevoir.',
    "results.retry": "Réessayer",
    "results.emailConfirm":
      "📩 Vous recevrez aussi vos résultats par email, pour y revenir quand vous voulez.",
    "results.downloadPdf": "Télécharger le PDF… à lire avant vos concurrents",
    "results.pdfFilename": "diagnostic-marketing-b2b-be-one.pdf",
    "results.cta": "Bookez un appel stratégique gratuit.",
    "results.ctaHref": "https://be-one.net/fr/calendly",
    "results.ctaSubtext":
      "Votre priorité mérite mieux qu'une bonne intention. 30 minutes, une lecture stratégique, un plan d'action. Choisissez votre créneau !",
    "results.restart": "Relancer une évaluation",
  },
  questions: assessmentQuestionsFr,
  feedback: {
    pillarFeedbacks: PILLAR_FEEDBACKS_FR,
    crossP2: CROSS_P2_FR,
    crossP3Uniforme: CROSS_P3_UNIFORME_FR,
    crossP3EnRetrait: CROSS_P3_EN_RETRAIT_FR,
    crossP3EnAvance: CROSS_P3_EN_AVANCE_FR,
  },
  radarAxisLabels: [
    "Stratégie\n& Pilotage",
    "Marque\n& Expérience",
    "Contenu\n& Visibilité",
    "IA\n& Outils",
  ],
};

export default fr;
